import React, { Suspense } from 'react';
import styles from './WorkPopup.module.css';

// Временное решение пока не созданы попапы
const DefaultPopupContent = ({ work }) => {
  return (
    <div className={styles.popupContent}>
      <div className={styles.popupHeader}>
        <h2 className={styles.popupTitle}>{work.title}</h2>
        <div className={styles.popupMeta}>
          <span className={styles.metaItem}>{work.category}</span>
          <span className={styles.metaItem}>{work.year}</span>
        </div>
      </div>
      
      {work.link1 && (
        <div className={styles.popupImageContainer}>
          <img 
            src={work.link1} 
            alt={work.title}
            className={styles.popupImage}
          />
        </div>
      )}
    </div>
  );
};

// Компоненты для ленивой загрузки
const Project1Popup = React.lazy(() => import('../popups/Project1Popup'));
const Project2Popup = React.lazy(() => import('../popups/Project2Popup'));
const Project3Popup = React.lazy(() => import('../popups/Project3Popup'));
const Project4Popup = React.lazy(() => import('../popups/Project4Popup'));
const Project5Popup = React.lazy(() => import('../popups/Project5Popup'));
const Project6Popup = React.lazy(() => import('../popups/Project6Popup'));
const Project7Popup = React.lazy(() => import('../popups/Project7Popup'));
const Project8Popup = React.lazy(() => import('../popups/Project8Popup'));

const PopupContent = ({ work }) => {
  // Динамический рендеринг в зависимости от work.popupComponent
  const renderContent = () => {
    if (!work.popupComponent) {
      return <DefaultPopupContent work={work} />;
    }

    switch(work.popupComponent) {
      case 'Project1Popup':
        return (
          <Suspense fallback={<div>Загрузка проекта 1...</div>}>
            <Project1Popup work={work} />
          </Suspense>
        );
      case 'Project2Popup':
        return (
          <Suspense fallback={<div>Загрузка проекта 2...</div>}>
            <Project2Popup work={work} />
          </Suspense>
        );
      case 'Project3Popup':
        return (
          <Suspense fallback={<div>Загрузка проекта 3...</div>}>
            <Project3Popup work={work} />
          </Suspense>
        );
      case 'Project4Popup':
        return (
          <Suspense fallback={<div>Загрузка проекта 4...</div>}>
            <Project4Popup work={work} />
          </Suspense>
        );
      case 'Project5Popup':
        return (
          <Suspense fallback={<div>Загрузка проекта 5...</div>}>
            <Project5Popup work={work} />
          </Suspense>
        );
      case 'Project6Popup':
        return (
          <Suspense fallback={<div>Загрузка проекта 6...</div>}>
            <Project6Popup work={work} />
          </Suspense>
        );
      case 'Project7Popup':
        return (
          <Suspense fallback={<div>Загрузка проекта 7...</div>}>
            <Project7Popup work={work} />
          </Suspense>
        );
      case 'Project8Popup':
        return (
          <Suspense fallback={<div>Загрузка проекта 8...</div>}>
            <Project8Popup work={work} />
          </Suspense>
        );
      default:
        return <DefaultPopupContent work={work} />;
    }
  };

  return renderContent();
};

export default PopupContent;